/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 5c9f76d10c5e
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { DirectionEnum, DirectionEnum$zodSchema } from "./directionenum.js";
import {
  UploadPresetListResponse,
  UploadPresetListResponse$zodSchema,
} from "./uploadpresetlistresponse.js";

/**
 * The field to sort presets by.
 */
export const OrderBy = {
  Name: "name",
  Id: "id",
  CreatedAt: "created_at",
} as const;
/**
 * The field to sort presets by.
 */
export type OrderBy = ClosedEnum<typeof OrderBy>;

export const OrderBy$zodSchema = z.enum([
  "name",
  "id",
  "created_at",
]).describe("The field to sort presets by.");

export type ListUploadPresetsGlobals = { cloud_name?: string | undefined };

export const ListUploadPresetsGlobals$zodSchema: z.ZodType<
  ListUploadPresetsGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type ListUploadPresetsRequest = {
  order_by?: OrderBy | undefined;
  direction?: DirectionEnum | undefined;
  max_results?: number | undefined;
  next_cursor?: string | undefined;
};

export const ListUploadPresetsRequest$zodSchema: z.ZodType<
  ListUploadPresetsRequest
> = z.object({
  direction: DirectionEnum$zodSchema.optional().describe(
    "The sort direction for the results. Default is \"desc\".",
  ),
  max_results: z.int().default(10).describe(
    "The maximum number of results to return. Default is 10.",
  ),
  next_cursor: z.string().describe(
    "The cursor for pagination. Use the next_cursor value from a previous response to get the next page of results.",
  ).optional(),
  order_by: OrderBy$zodSchema.optional().describe(
    "The field to sort presets by.",
  ),
});

export type ListUploadPresetsResponse = UploadPresetListResponse | ApiError;

export const ListUploadPresetsResponse$zodSchema: z.ZodType<
  ListUploadPresetsResponse
> = z.union([
  UploadPresetListResponse$zodSchema,
  ApiError$zodSchema,
]);
